import React from 'react'
import { Box, Text, Modal, Heading, Flex } from '@moonpig/launchpad-components'
import { TextInput } from '@moonpig/launchpad-forms'
import { Region } from '@moonpig/web-core-types'
import {
  IllustrationBubbleError,
  IconSystemEnvelope,
} from '@moonpig/launchpad-assets'
import moonpigGlassesIcon from './IllustrationBrandGlasses.svg'
import { useAuthenticationLocaleText } from '../../text-localisation'

/* istanbul ignore next */
const noop = () => {}

export const ValidateEmailWarningModal: React.FC<{
  isOpen: boolean
  onDismiss: () => void
  email: string
  region: Region
}> = ({ isOpen, email, onDismiss, region }) => {
  const localiseText = useAuthenticationLocaleText()

  return (
    <Modal
      label={localiseText('auth_wizard.validate_email_header')}
      isOpen={isOpen}
      onDismiss={onDismiss}
      hasCloseButton
      mobilePagePeek
    >
      <Box justifyContent="center" width={{ xs: '100vw', md: 1 }}>
        <Box mb={6}>
          {region === 'nl' ? (
            /* istanbul ignore next */ <IllustrationBubbleError
              width="100px"
              height="100px"
            />
          ) : (
            <img src={moonpigGlassesIcon} alt="moonpig glasses icon" />
          )}
        </Box>
        <Heading
          level="h2"
          typography={{ xs: 'typeMobileDisplay03', md: 'typeDesktopDisplay04' }}
          mb={6}
        >
          {localiseText('auth_wizard.validate_email_header')}
        </Heading>
        <Text as="div" mb={6}>
          {localiseText('auth_wizard.validate_email_message')}
        </Text>
        <Flex flexDirection={{ xs: 'column', md: 'row' }} mb={6}>
          <Box flexGrow={4}>
            <TextInput
              mb={{ xs: 6, md: 0 }}
              label=""
              name="e"
              value={email}
              disabled
              onChange={noop}
              componentStart={
                <IconSystemEnvelope
                  width="28px"
                  height="28px"
                  style={{
                    position: 'absolute',
                    top: '50%',
                    right: '50%',
                    transform: 'translate(50%, -50%)',
                    opacity: 0.5,
                  }}
                />
              }
            />
          </Box>
        </Flex>
      </Box>
    </Modal>
  )
}
